// src/context/ToggleContext.js
import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const ToggleContext = createContext();

// Create a provider component
export const ToggleProvider = ({ children }) => {
    // Initialize state from localStorage or use default values
    const [toggles, setToggles] = useState(() => {
        const savedToggles = localStorage.getItem('toggles');
        return savedToggles ? JSON.parse(savedToggles) : {};
    });

    // Update localStorage whenever toggles change
    useEffect(() => {
        localStorage.setItem('toggles', JSON.stringify(toggles));
    }, [toggles]);

    // Function to toggle a specific toggle
    const toggle = (id) => {
        setToggles((prevToggles) => ({
            ...prevToggles,
            [id]: !prevToggles[id],
        }));
    };

    return (
        <ToggleContext.Provider value={{ toggles, toggle }}>
            {children}
        </ToggleContext.Provider>
    );
};
